// extracted by mini-css-extract-plugin
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";
export var socialMediaPostsContainer = "social-media-post-list-module--social-media-posts-container--a44d5";
export var tweetContainer = "social-media-post-list-module--tweet-container--5f858";